"use strict";
/**
 * Created by Ning Jiang on 3/21/2017.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetWayWinIndividualWPController = void 0;
const GameConfig_1 = require("../../../core/gameconfig/GameConfig");
const Reels_1 = require("../../../core/reel/reelarea/Reels");
const IndividualWinPresentationController_1 = require("../../../core/winpresentation/individualwin/IndividualWinPresentationController");
const gsap_1 = require("gsap");
class BetWayWinIndividualWPController extends IndividualWinPresentationController_1.IndividualWinPresentationController {
    constructor(config, name = "BetWayIndividualWin", tweakEnabled) {
        super(name, tweakEnabled, 2 /* BetWinMode.BET_WAY */);
        this._config = config;
    }
    getLineAnimation(betWayWinData) {
        const timeline = new gsap_1.TimelineLite();
        const reelsNum = betWayWinData.length;
        let currentDuration = 0;
        for (let i = 0; i < reelsNum; i++) {
            for (let j = 0; j < betWayWinData.reelWinPositions[i].length; j++) {
                if (betWayWinData.reelWinPositions[i][j]) {
                    const symbol = Reels_1.Reels.getSymbol(i, j);
                    if (symbol) {
                        this.addSymbolWinAnimationToTimeline(betWayWinData, timeline, this._config.symbolTimeOffsetCalculator(currentDuration, i, j), symbol, i, j);
                        if (this._winSymbols.indexOf(symbol) === -1) {
                            this._winSymbols.push(symbol);
                        }
                    }
                }
            }
            currentDuration = timeline.totalDuration();
        }
        return timeline;
    }
    addSymbolWinAnimationToTimeline(betWayWinData, timeline, startTime, symbol, reelId, symbolId) {
        timeline.add([
            () => this.sortSymbolDepthToTop(symbol),
            symbol.changeState({
                state: GameConfig_1.GameConfig.instance.SYMBOL_STATES.win,
                setStack: true,
                fadeInDuration: 0.4
            })
        ], startTime);
    }
    sortSymbolDepthToTop(symbol) {
        if (symbol && symbol.parent) {
            symbol.parent.addChild(symbol);
        }
    }
}
exports.BetWayWinIndividualWPController = BetWayWinIndividualWPController;
//# sourceMappingURL=BetWayWinIndividualWPController.js.map